import { gql } from '@utils/gpl-dedup';

export const addressFragment = gql`
  fragment address on Address {
    id
    line_1
    line_2
    country
    state
    city
    county
    postal
    is_postal
    is_billing
    is_office
    created_at
    updated_at
  }
`;
